import React from "react";
import type { MenuItem } from "@/constants/Menu";

export const ArticleToolCard: React.FC<{ tool: MenuItem }> = ({ tool }) => {
  return (
    <a
      href={tool.href}
      className="my-4 flex items-center gap-4 rounded-2xl border border-primary-100 bg-white p-3 shadow-sm transition hover:border-primary-300 hover:bg-primary-50"
    >
      <img
        src={tool.imageSrc}
        alt=""
        loading="lazy"
        className="h-20 w-28 flex-none rounded-xl object-cover"
      />
      <div className="min-w-0 flex-1">
        <p className="text-xs text-primary-400">Nekometryのツール</p>
        <p className="font-bold text-primary-800">{tool.title}</p>
        <p className="text-sm leading-6 text-primary-600">{tool.description}</p>
      </div>
      <span aria-hidden="true" className="flex-none text-primary-400">
        →
      </span>
    </a>
  );
};
